export default "__VITE_ASSET__CyyIVpJU__"